"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CGJGameScene = exports.CGJSeason = void 0;
const CGJPlayer_1 = require("./CGJPlayer");
const CGJEnemy_1 = require("./CGJEnemy");
const CGJCycleGraphic_1 = require("./CGJCycleGraphic");
const CGJCycle_1 = require("./CGJCycle");
const CGJStage_1 = require("./CGJStage");
const KHUnifiedInput_1 = require("./KH/Input/KHUnifiedInput");
const KHController_1 = require("./KH/Input/KHController");
const KHInputAxisFromKeys_1 = require("./KH/Input/KHInputAxisFromKeys");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHInputProviderController_1 = require("./KH/Input/KHInputProviderController");
const CGJController_1 = require("./CGJController");
const KHInputProviderMouse_1 = require("./KH/Input/KHInputProviderMouse");
const KHInputKeyResettable_1 = require("./KH/Input/KHInputKeyResettable");
const KHInputSet_1 = require("./KH/Input/KHInputSet");
var CGJSeason;
(function (CGJSeason) {
    CGJSeason[CGJSeason["Fall"] = 0] = "Fall";
    CGJSeason[CGJSeason["Winter"] = 1] = "Winter";
    CGJSeason[CGJSeason["Spring"] = 2] = "Spring";
    CGJSeason[CGJSeason["Summer"] = 3] = "Summer";
})(CGJSeason = exports.CGJSeason || (exports.CGJSeason = {}));
class CGJGameScene extends Phaser.Scene {
    constructor() {
        super("CGJGameScene");
    }
    init(data) {
        this.initData = data ? data : null;
    }
    create() {
        this.width = Number(this.game.config.width);
        this.height = Number(this.game.config.height);
        this.cwidth = 31 * 32;
        this.cheight = 31 * 32;
        this.currentSpeedModifier = 1;
        this.points = 0;
        this.gameTime = 0;
        this.paused = false;
        const x = (this.width - this.cwidth) / 2;
        const y = (this.height - this.cheight) / 2;
        this.worldRect = new Phaser.Geom.Rectangle(x + 32, y + 32, this.cwidth - 64, this.cheight - 64);
        this.moveToWorldRect = new Phaser.Geom.Rectangle(this.worldRect.x + 10, this.worldRect.y + 12, this.worldRect.width - 28, this.worldRect.height - 10);
        this.worldRectLines = [
            new Phaser.Geom.Line(this.moveToWorldRect.x, this.moveToWorldRect.y, this.moveToWorldRect.x + this.moveToWorldRect.width, this.moveToWorldRect.y),
            new Phaser.Geom.Line(this.moveToWorldRect.x, this.moveToWorldRect.y, this.moveToWorldRect.x, this.moveToWorldRect.y + this.moveToWorldRect.height),
            new Phaser.Geom.Line(this.moveToWorldRect.x, this.moveToWorldRect.y + this.moveToWorldRect.height, this.moveToWorldRect.x + this.moveToWorldRect.width, this.moveToWorldRect.y + this.moveToWorldRect.height),
            new Phaser.Geom.Line(this.moveToWorldRect.x + this.moveToWorldRect.width, this.moveToWorldRect.y, this.moveToWorldRect.x + this.moveToWorldRect.width, this.moveToWorldRect.y + this.moveToWorldRect.height),
        ];
        this.physics.world.setBounds(this.worldRect.x, this.worldRect.y, this.worldRect.width, this.worldRect.height);
        this.space = this.add.image(0, 0, 'Space').setDepth(-2).setOrigin(0).setTint(0x888888);
        this.background = new CGJStage_1.CGJStage(this, CGJSeason.Summer, x, y, this.cwidth, this.cheight).setDepth(-1);
        this.add.existing(this.background);
        this.foreground = this.add.sprite(0, 0, 'Pixel').setOrigin(0).setDisplaySize(this.width, this.height).setDepth(200000);
        this.foreground.setTint(0x0);
        this.setNightAlpha(0);
        this.enemies = [];
        this.collectables = [];
        this.cycleSpeed = this.initData.speed ? this.initData.speed : 1;
        this.pointTarget = this.initData.target && this.initData.target > 0 ? this.initData.target : null;
        this.moveTarget = null;
        this.scene.run("CGJHUDScene");
        this.hud = this.scene.get("CGJHUDScene");
        this.anims.create({ key: 'SlimeS', frames: this.anims.generateFrameNumbers('Slime', { start: 0, end: 2 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SlimeW', frames: this.anims.generateFrameNumbers('Slime', { start: 3, end: 5 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SlimeE', frames: this.anims.generateFrameNumbers('Slime', { start: 6, end: 8 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SlimeN', frames: this.anims.generateFrameNumbers('Slime', { start: 9, end: 11 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'BoyS', frames: this.anims.generateFrameNumbers('Boy', { start: 0, end: 2 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'BoyW', frames: this.anims.generateFrameNumbers('Boy', { start: 3, end: 5 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'BoyE', frames: this.anims.generateFrameNumbers('Boy', { start: 6, end: 8 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'BoyN', frames: this.anims.generateFrameNumbers('Boy', { start: 9, end: 11 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'GirlS', frames: this.anims.generateFrameNumbers('Girl', { start: 0, end: 2 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'GirlW', frames: this.anims.generateFrameNumbers('Girl', { start: 3, end: 5 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'GirlE', frames: this.anims.generateFrameNumbers('Girl', { start: 6, end: 8 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'GirlN', frames: this.anims.generateFrameNumbers('Girl', { start: 9, end: 11 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SkeletonS', frames: this.anims.generateFrameNumbers('Skeleton', { start: 0, end: 2 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SkeletonW', frames: this.anims.generateFrameNumbers('Skeleton', { start: 3, end: 5 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SkeletonE', frames: this.anims.generateFrameNumbers('Skeleton', { start: 6, end: 8 }), frameRate: 16, repeat: -1 });
        this.anims.create({ key: 'SkeletonN', frames: this.anims.generateFrameNumbers('Skeleton', { start: 9, end: 11 }), frameRate: 16, repeat: -1 });
        this.tickSound = this.sound.add('Tick');
        this.gongSound = this.sound.add('Gong');
        this.daySound = this.sound.add('Bird');
        this.nightSound = this.sound.add('Cricket');
        this.pickupSound = this.sound.add('Pickup');
        this.deathSound = this.sound.add('Death');
        this.season = CGJSeason.Fall;
        this.addPlayer();
        this.cycles = [];
        this.cycleHeight = 0;
        this.addCycle(200, new CGJCycle_1.CGJCycle(this.gongSound, [
            new CGJCycle_1.CGJCycleElement("Fall", 20000, 0x6C2F00, null, () => this.setSeason(CGJSeason.Fall), null, null, [
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x008800, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Death", 3000, 0x770000, null, () => { this.removeFirstEnemyOfType(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x008800, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 1000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Death", 3000, 0x770000, null, () => { this.removeFirstEnemyOfType(CGJEnemy_1.CGJEnemyType.Slime); }, null, null),
                ]),
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Spawn", 3900, 0x007700, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 100, 0x654321, null, () => { this.removeCollectible(); }, null, null),
                ])
            ]),
            new CGJCycle_1.CGJCycleElement("Winter", 20000, 0xB3DAF1, null, () => this.setSeason(CGJSeason.Winter), null, null, [
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Birth", 2000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 2000, 0x008800, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 2000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Death", 4000, 0x770000, null, () => { this.removeFirstEnemyOfType(CGJEnemy_1.CGJEnemyType.Skeleton); }, null, null),
                ]),
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Spawn", 4900, 0x007700, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 100, 0x654321, null, () => { this.removeCollectible(); }, null, null),
                ])
            ]),
            new CGJCycle_1.CGJCycleElement("Spring", 20000, 0xF3A8BC, null, () => this.setSeason(CGJSeason.Spring), null, null, [
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Birth", 19000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.SkeletonLarge); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Death", 1000, 0x770000, null, () => {
                        this.removeFirstEnemyOfType(CGJEnemy_1.CGJEnemyType.SkeletonLarge);
                        this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton);
                        this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton);
                        this.addEnemy(CGJEnemy_1.CGJEnemyType.Skeleton);
                    }, null, null),
                ]),
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Spawn", 200, 0x007700, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Spawn", 200, 0x006600, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Spawn", 200, 0x007700, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Spawn", 8600, 0x006600, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 200, 0x654321, null, () => { this.removeCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 200, 0x543210, null, () => { this.removeCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 200, 0x654321, null, () => { this.removeCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 200, 0x543210, null, () => { this.removeCollectible(); }, null, null),
                ])
            ]),
            new CGJCycle_1.CGJCycleElement("Summer", 20000, 0xE0E300, null, () => this.setSeason(CGJSeason.Summer), null, null, [
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Birth", 3000, 0x007700, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.SlimeLarge); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Birth", 3000, 0x008800, null, () => { this.addEnemy(CGJEnemy_1.CGJEnemyType.SlimeLarge); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Death", 4000, 0x770000, null, () => { this.removeFirstEnemyOfType(CGJEnemy_1.CGJEnemyType.SlimeLarge); }, null, null),
                ]),
                new CGJCycle_1.CGJCycle(this.tickSound, [
                    new CGJCycle_1.CGJCycleElement("Spawn", 1900, 0x007700, null, () => { this.addCollectible(); }, null, null),
                    new CGJCycle_1.CGJCycleElement("Rot", 100, 0x654321, null, () => { this.removeCollectible(); }, null, null),
                ])
            ]),
        ]));
        this.addCycle(65, new CGJCycle_1.CGJCycle(null, [
            new CGJCycle_1.CGJCycleElement("Day", 3000, 0x87CEEB, null, () => { this.setEnemySpeedModifier(1.25); this.setNightAlpha(0); }, null, null),
            new CGJCycle_1.CGJCycleElement("Dusk", 2000, 0x5C777F, this.nightSound, () => this.setEnemySpeedModifier(1), null, (time, delta, percent) => { this.setNightAlpha(percent); }),
            new CGJCycle_1.CGJCycleElement("Night", 3000, 0x000033, null, () => { this.setEnemySpeedModifier(0.75); this.setNightAlpha(1); }, null, null),
            new CGJCycle_1.CGJCycleElement("Dawn", 2000, 0x5C777F, this.daySound, () => this.setEnemySpeedModifier(1), null, (time, delta, percent) => { this.setNightAlpha(1 - percent); }),
        ]), 250);
        this.add.sprite(x / 2, 250, 'StoneHead').setScale(4);
        this.pointsText = this.add.text(x / 2, this.cycleHeight + 50, "", { fontFamily: 'NovaMono,Monospace', color: '#FFFFFF' }).setFontSize(50).setOrigin(0.5);
        this.updatePointText();
        this.controller = this.getController();
        this.controller.register(KHInputScene_1.KHInputScene.SharedInput);
        console.log("create");
        this.events.on('shutdown', () => {
            this.controller.unregister();
        });
    }
    getController() {
        const inputSet = new KHInputSet_1.KHInputSet("controller");
        let axisMap = new Map();
        // Y-axis
        {
            let yAxes = [
                new KHInputAxisFromKeys_1.KHInputAxisFromKeys(inputSet, KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.DOWN, Phaser.Input.Keyboard.KeyCodes.S], [KHInputProviderController_1.PadInput.Down]), KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.UP, Phaser.Input.Keyboard.KeyCodes.W], [KHInputProviderController_1.PadInput.Up]))
            ];
            yAxes.push(...KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledRadial(inputSet, KHInputProviderController_1.PadAxis.LeftStickY, KHInputProviderController_1.PadAxis.LeftStickX, 0.25));
            let yAxis = KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, yAxes);
            axisMap.set(CGJController_1.CGJAxis.MoveY, yAxis);
        }
        // X-axis
        {
            let xAxes = [
                new KHInputAxisFromKeys_1.KHInputAxisFromKeys(inputSet, KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.RIGHT, Phaser.Input.Keyboard.KeyCodes.D], [KHInputProviderController_1.PadInput.Right]), KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.LEFT, Phaser.Input.Keyboard.KeyCodes.A], [KHInputProviderController_1.PadInput.Left]))
            ];
            xAxes.push(...KHUnifiedInput_1.KHUnifiedInput.GetControllerAxesScaledRadial(inputSet, KHInputProviderController_1.PadAxis.LeftStickX, KHInputProviderController_1.PadAxis.LeftStickY, 0.25));
            let xAxis = KHUnifiedInput_1.KHUnifiedInput.GetCombinedAxis(inputSet, xAxes);
            axisMap.set(CGJController_1.CGJAxis.MoveX, xAxis);
        }
        const mouse = KHInputScene_1.KHInputScene.SharedInput.mouseProvider;
        axisMap.set(CGJController_1.CGJAxis.TargetX, mouse.getAxis(KHInputProviderMouse_1.MouseAxis.X));
        axisMap.set(CGJController_1.CGJAxis.TargetY, mouse.getAxis(KHInputProviderMouse_1.MouseAxis.Y));
        const inputMap = new Map();
        this.mouseInput = new KHInputKeyResettable_1.KHInputKeyResettable(inputSet, mouse.getInput(KHInputProviderMouse_1.MouseInput.Left));
        this.mouseInput.reset();
        inputMap.set(CGJController_1.CGJInput.GoToTarget, this.mouseInput);
        inputMap.set(CGJController_1.CGJInput.Pause, KHUnifiedInput_1.KHUnifiedInput.UnifiedInput(inputSet, [Phaser.Input.Keyboard.KeyCodes.P, Phaser.Input.Keyboard.KeyCodes.ESC], [KHInputProviderController_1.PadInput.Start]));
        return new CGJController_1.CGJController(inputMap, axisMap, inputSet);
    }
    lose() {
        this.player.kill();
        this.deathSound.play();
        this.time.addEvent({ delay: 2000, callback: () => {
                const divisor = this.pointTarget ? "/" + this.pointTarget : "";
                const singular = this.pointTarget ? this.pointTarget == 1 : this.points == 1;
                const apples = singular ? " apple." : " apples.";
                this.showPause("You failed to appease Cyclus.\nYou collected " + this.points + divisor + apples, (pause_response) => {
                    this.handlePause(pause_response);
                });
            } });
    }
    showPause(reason, callback) {
        this.paused = true;
        this.scene.pause(this.scene.key);
        this.hud.showPauseMenu(reason, callback);
    }
    handlePause(action) {
        this.paused = false;
        this.scene.resume(this.scene.key);
        switch (action) {
            case "menu":
                this.startScene("CGJMenuScene");
                break;
            case "restart":
                this.scene.restart();
                break;
            case "resume":
                break;
            default:
                console.log("Unrecognized action " + action);
                break;
        }
        this.mouseInput.reset();
    }
    startScene(scene, data = {}) {
        this.scene.stop(this.hud.scene.key);
        this.scene.start(scene, data);
    }
    addCycle(radius, cycle, yOverride = null) {
        const x = (this.width - this.cwidth) / 2;
        const y = yOverride ? yOverride : (50 + this.cycleHeight + radius);
        const cycleGraphic = new CGJCycleGraphic_1.CGJCycleGraphic(this, x / 2, y, radius, cycle);
        this.cycles.push(cycleGraphic);
        if (!yOverride) {
            this.cycleHeight += 50 + radius * 2;
        }
        this.add.existing(cycleGraphic);
        const pointer = this.add.sprite(cycleGraphic.x, cycleGraphic.y + cycleGraphic.radius, 'Pointer').setOrigin(0.5, 0);
        pointer.setDisplaySize(24, 24);
    }
    setEnemySpeedModifier(speed) {
        for (let i = 0; i < this.enemies.length; i++) {
            this.enemies[i].speedModifier = speed;
        }
    }
    setNightAlpha(percent) {
        this.foreground.setAlpha(0.5 * percent);
    }
    setSeason(season) {
        this.background.setSeason(season);
    }
    addPlayer() {
        const pos = this.getPoint();
        this.player = new CGJPlayer_1.CGJPlayer(this, pos, this.height / 20).setDepth(1);
        this.add.existing(this.player);
    }
    addEnemy(type) {
        let enemy;
        switch (type) {
            case CGJEnemy_1.CGJEnemyType.Slime:
                enemy = new CGJEnemy_1.CGJEnemy(this, CGJEnemy_1.CGJEnemyType.Slime, "Slime", CGJEnemy_1.CGJEnemyBehavior.RandomDir, new Phaser.Geom.Rectangle(2, 8, 12, 8), null, this.getPoint(), this.height / 20, Math.random() * 6.28, Phaser.Math.Between(100, 200));
                break;
            case CGJEnemy_1.CGJEnemyType.Skeleton:
                enemy = new CGJEnemy_1.CGJEnemy(this, CGJEnemy_1.CGJEnemyType.Skeleton, "Skeleton", CGJEnemy_1.CGJEnemyBehavior.RandomDir, new Phaser.Geom.Rectangle(3, 12, 10, 4), null, this.getPoint(), this.height / 20, Math.random() * 6.28, Phaser.Math.Between(100, 200));
                break;
            case CGJEnemy_1.CGJEnemyType.SlimeLarge:
                enemy = new CGJEnemy_1.CGJEnemy(this, CGJEnemy_1.CGJEnemyType.SlimeLarge, "Slime", CGJEnemy_1.CGJEnemyBehavior.RandomDir, new Phaser.Geom.Rectangle(2, 8, 12, 8), null, this.getPoint(), this.height / 10, Math.random() * 6.28, Phaser.Math.Between(50, 100));
                break;
            case CGJEnemy_1.CGJEnemyType.SkeletonLarge:
                enemy = new CGJEnemy_1.CGJEnemy(this, CGJEnemy_1.CGJEnemyType.SkeletonLarge, "Skeleton", CGJEnemy_1.CGJEnemyBehavior.Follow, new Phaser.Geom.Rectangle(3, 12, 10, 4), null, this.getPoint(), this.height / 5, Math.random() * 6.28, Phaser.Math.Between(50, 100));
                break;
        }
        enemy.setDepth(1);
        enemy.speedModifier = this.currentSpeedModifier;
        for (let i = 0; i < this.enemies.length; i++) {
            this.physics.add.collider(this.enemies[i], enemy);
        }
        this.enemies.push(enemy);
    }
    addCollectible() {
        const pos = this.getPoint();
        const collect = this.physics.add.sprite(pos.x, pos.y, 'Apple');
        collect.setDisplaySize(this.height / 20, this.height / 20);
        collect.tint = 0xFF0000;
        this.collectables.push(collect);
        this.physics.add.overlap(this.player, collect, () => {
            collect.destroy();
            this.addCollectedCollectable();
        });
    }
    addCollectedCollectable() {
        this.pickupSound.play();
        this.points++;
        const divisor = this.pointTarget ? "/" + this.pointTarget : "";
        const singular = this.pointTarget ? this.pointTarget == 1 : this.points == 1;
        const apples = singular ? " Apple" : " Apples";
        this.pointsText.setText("" + this.points + divisor + apples);
        const x = (this.width - this.cwidth) / 4;
        const percent = (this.points / (this.pointTarget ? this.pointTarget : 50));
        const radius = 200;
        const angle = percent * Math.PI * 8;
        const dist = radius * (percent % 1);
        this.add.sprite(Math.cos(angle) * dist + x, Math.sin(angle) * dist + this.cycleHeight + 50 + radius, 'Apple').setScale(2);
        if (this.pointTarget == this.points) {
            this.startScene("CGJWinScene");
        }
    }
    updatePointText() {
        const divisor = this.pointTarget ? "/" + this.pointTarget : "";
        this.pointsText.setText("" + this.points + divisor + " Apples");
    }
    removeCollectible() {
        if (this.collectables.length < 1)
            return;
        const collect = this.collectables[0];
        this.collectables.splice(0, 1);
        collect.destroy();
    }
    getPoint() {
        let pos = new Phaser.Geom.Point();
        const spriteBounds = Phaser.Geom.Rectangle.Inflate(Phaser.Geom.Rectangle.Clone(this.physics.world.bounds), -100, -100);
        for (let i = 0; i < 100; i++) {
            Phaser.Geom.Rectangle.Random(spriteBounds, pos);
            if (this.player && !this.acceptableDist(pos.x, pos.y, this.player.x, this.player.y, 200))
                continue;
            for (let j = 0; j < this.enemies.length; j++) {
                if (!this.acceptableDist(pos.x, pos.y, this.enemies[j].x, this.enemies[j].y, 50))
                    continue;
            }
            return pos;
        }
        console.log("Bailed out");
        return pos;
    }
    acceptableDist(x1, y1, x2, y2, dist) {
        const dx = x1 - x2;
        const dy = y1 - y2;
        return dx * dx + dy * dy > dist * dist;
    }
    removeFirstEnemy() {
        this.removeEnemy(0);
    }
    removeFirstEnemyOfType(type) {
        for (let i = 0; i < this.enemies.length; i++) {
            if (this.enemies[i].enemyType == type) {
                this.removeEnemy(i);
                return;
            }
        }
    }
    removeEnemy(idx) {
        if (idx >= this.enemies.length)
            return;
        const enemy = this.enemies[idx];
        this.enemies.splice(idx, 1);
        enemy.kill();
    }
    update(now, delta) {
        if (this.paused) {
            return;
        }
        this.gameTime += delta;
        const status = this.controller.getStatus();
        if (status[KHController_1.KHInputType.Key].get(CGJController_1.CGJInput.Pause)[KHController_1.KHInputStatus.JustDown]) {
            this.showPause(null, (pause_response) => {
                this.handlePause(pause_response);
            });
        }
        for (let i = 0; i < this.cycles.length; i++) {
            this.cycles[i].cycle.update(this.gameTime * this.cycleSpeed, delta * this.cycleSpeed);
        }
        this.physics.collide(this.player, this.enemies, () => {
            this.lose();
        });
        if (status[KHController_1.KHInputType.Key].get(CGJController_1.CGJInput.GoToTarget)[KHController_1.KHInputStatus.Down]) {
            const tentativeMoveTarget = new Phaser.Math.Vector2(status[KHController_1.KHInputType.Axis].get(CGJController_1.CGJAxis.TargetX)[KHController_1.KHAxisStatus.Value], status[KHController_1.KHInputType.Axis].get(CGJController_1.CGJAxis.TargetY)[KHController_1.KHAxisStatus.Value]);
            if (!this.moveToWorldRect.contains(tentativeMoveTarget.x, tentativeMoveTarget.y)) {
                const line = new Phaser.Geom.Line(this.player.body.position.x, this.player.body.position.y, tentativeMoveTarget.x, tentativeMoveTarget.y);
                let intersect = new Phaser.Geom.Point();
                for (let i = 0; i < this.worldRectLines.length; i++) {
                    if (Phaser.Geom.Intersects.LineToLine(line, this.worldRectLines[i], intersect)) {
                        break;
                    }
                }
                if (intersect.x != 0 || intersect.y != 0) {
                    tentativeMoveTarget.x = intersect.x;
                    tentativeMoveTarget.y = intersect.y;
                    this.moveTarget = tentativeMoveTarget;
                }
            }
            else {
                this.moveTarget = tentativeMoveTarget;
            }
        }
        let movement = new Phaser.Math.Vector2(status[KHController_1.KHInputType.Axis].get(CGJController_1.CGJAxis.MoveX)[KHController_1.KHAxisStatus.Value], status[KHController_1.KHInputType.Axis].get(CGJController_1.CGJAxis.MoveY)[KHController_1.KHAxisStatus.Value]);
        if (movement.lengthSq() > 1) {
            movement = movement.normalize();
        }
        const moveSpeed = 300;
        const actualSpeed = moveSpeed * movement.length();
        if (movement.x != 0 || movement.y != 0) {
            this.moveTarget = null;
            this.player.body.velocity.x = movement.x * moveSpeed;
            this.player.body.velocity.y = movement.y * moveSpeed;
            this.player.anims.timeScale = actualSpeed / moveSpeed;
        }
        else if (this.moveTarget) {
            this.physics.moveTo(this.player, this.moveTarget.x, this.moveTarget.y, moveSpeed);
            const maxDistance = 10;
            if (Phaser.Math.Distance.Between(this.player.body.position.x + 16, this.player.body.position.y + 12, this.moveTarget.x, this.moveTarget.y) < maxDistance) {
                this.player.body.velocity.x = 0;
                this.player.body.velocity.y = 0;
                this.moveTarget = null;
            }
        }
        else {
            this.player.body.velocity.x = 0;
            this.player.body.velocity.y = 0;
        }
        this.player.update(this.gameTime, delta);
        for (let i = 0; i < this.enemies.length; i++) {
            this.enemies[i].update(this.gameTime, delta);
        }
    }
}
exports.CGJGameScene = CGJGameScene;
